import { FC } from "react"
import { ContactFormDetails } from "../../../../../../types"
import ContactFormGeneral from "./sections/general"
import ContactFormFields from "./sections/fields"

interface Props {
  values: ContactFormDetails
  tab: string
  setFormField: (name: string, value: any) => void
}

const ManageContactFormContent: FC<Props> = ({ values, tab, setFormField }) => {
  const setConfigField = (field: string, value: any) =>
    setFormField("config", { ...values.config, [field]: value })

  return (
    <>
      {tab === "general" && (
        <ContactFormGeneral values={values} setConfigField={setConfigField} />
      )}
      {tab === "fields" && (
        <ContactFormFields values={values} setConfigField={setConfigField} />
      )}
    </>
  )
}

export default ManageContactFormContent
